class CallToIcons extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.call-to-icon-item');
    this.hasAnimated = false;
  }

  connectedCallback() {
    // Check for reduced motion preference
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion && reducedMotion.matches) {
      // Apply no animation if user prefers reduced motion
      this.items.forEach(item => {
        item.style.opacity = '1';
        item.style.transform = 'translateX(0)';
      });
      return;
    }

    // Use Intersection Observer for scroll-triggered animation
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.animateItems();
            this.hasAnimated = true;
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  animateItems() {
    this.items.forEach((item, index) => {
      const delay = parseInt(item.dataset.animateDelay || index * 100, 10);
      
      setTimeout(() => {
        item.classList.add('animate-in');
      }, delay);
    });
  }
}

// Define the custom element
if (!customElements.get('call-to-icons-section')) {
  customElements.define('call-to-icons-section', CallToIcons);
}

